/** URL param carrying the children ages of a hotel search, e.g. `childrenAges=8,4`. */
export const CHILDREN_AGES_PARAM = 'childrenAges';

/** Highest age searched as a child; from 18 on a guest counts as an adult. */
export const MAX_CHILD_AGE = 17;

export function isValidChildAge(value: unknown): value is number {
  return (
    typeof value === 'number' && Number.isInteger(value) && value >= 0 && value <= MAX_CHILD_AGE
  );
}

/** Parses `8,4` into `[8, 4]`; undefined when absent or any age is invalid. */
export function parseChildrenAgesParam(value: string | null): number[] | undefined {
  if (!value) return undefined;
  const ages = value.split(',').map((age) => (age.trim() === '' ? NaN : Number(age)));
  return ages.every(isValidChildAge) ? ages : undefined;
}

export function formatChildrenAgesParam(
  ages: (number | undefined)[] | undefined,
): string | undefined {
  if (!ages?.length || !ages.every(isValidChildAge)) return undefined;
  return ages.join(',');
}
